import { render, staticRenderFns } from "./DettaglioQuestionario.vue?vue&type=template&id=703bad53&"
import script from "./DettaglioQuestionario.vue?vue&type=script&lang=js&"
export * from "./DettaglioQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports